import { createFeatureSelector, createSelector } from '@ngrx/store';

import { flyoutFeatureKey } from './flyout.reducer';
import { FlyoutState } from './flyout.state';

export const selectFlyoutFeatureState = createFeatureSelector<FlyoutState>(flyoutFeatureKey);

export const selectIsShowFlyout = (flyoutId: string) =>
    createSelector(selectFlyoutFeatureState, (state: FlyoutState) => {
        return flyoutId in state.flyouts ? state.flyouts[flyoutId] : false;
    });
